import type { CSSProperties, FC } from "react";
import { memo } from "react";
import { useDrag, useDrop } from "react-dnd";

const style: CSSProperties = {
  border: "1px dashed gray",
  padding: "0.5rem 1rem",
  marginBottom: ".5rem",
  backgroundColor: "white",
  cursor: "move",
};

export interface CardProps {
  id: string;
  text: string;
  moveCard: (id: string, to: number) => void;
  findCard: (id: string) => { index: number };
  childCategories: any;
  handleEditChilds: any;
}

interface Item {
  id: string;
  originalIndex: number;
}

export const ItemTypes = {
  CARD: "card",
};

export const CategoryCard: FC<CardProps> = memo(function CategoryCard({
  id,
  text,
  moveCard,
  findCard,
  childCategories,
  handleEditChilds,
}) {
  const originalIndex = findCard(id).index;
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.CARD,
      item: { id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          moveCard(droppedId, originalIndex);
        }
      },
    }),
    [id, originalIndex, moveCard]
  );

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.CARD,
      hover({ id: draggedId }: Item) {
        if (draggedId !== id) {
          const { index: overIndex } = findCard(id);
          moveCard(draggedId, overIndex);
        }
      },
    }),
    [findCard, moveCard]
  );

  const opacity = isDragging ? 0 : 1;
  return (
    <div ref={(node) => drag(drop(node))} style={{ ...style, opacity }}>
      <div className="flex justify-between">
        {text}
        <a
          href="link"
          className={`${childCategories?.length ? "visible" : "invisible"}`}
          onClick={(e) => {
            e.preventDefault();
            handleEditChilds(childCategories);
          }}
        >
          Edit Sub Categories
        </a>
      </div>
    </div>
  );
});
